import React, { Component } from "react";
import {
    Container, Col, Form,
    FormGroup, Label, Input,
    Button, Alert
  } from 'reactstrap';

import Header from '../components/Header'
import queryString from 'stringquery';
import { connect } from 'react-redux';
import { setUser, loginUser, OauthLogin, receiveLogin } from '../reducers/actions';
import { Redirect } from 'react-router-dom';

class Login extends Component {
  constructor(props) {
    super(props);

    this.state = {
      username: "",
      password: "",
      newPassword: "",
      confirmNewPassword: "",
      parsed : queryString(this.props.location.search),
      firstLoginMode: false,  // true when the user must set their own password
      firstLoginError: null,
      ...props
    };
  }

  componentDidMount() {
    fetch('/api/setup/status')
      .then(r => r.json())
      .then(data => {
        if (data.setupRequired) {
          this.props.history.replace('/auth/setup');
        }
      })
      .catch(() => {});
  }

  validateForm() {
    return this.state.username.length > 0 && this.state.password.length > 0;
  }

  validateFirstLoginForm() {
    return (
      this.state.username.length > 0 &&
      this.state.newPassword.length >= 12 &&
      this.state.newPassword === this.state.confirmNewPassword
    );
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  // Called when the username field loses focus — check if a first-login password
  // set is required for this user.
  handleUsernameBlur = event => {
    const username = event.target.value.trim().toUpperCase();
    this.setState({ username });

    if (!username) return;

    fetch(`/api/security/validateuser?username=${encodeURIComponent(username)}`)
      .then(r => r.json())
      .then(data => {
        if (data.requirePasswordChange) {
          this.setState({ firstLoginMode: true, firstLoginError: null });
        } else {
          // User exists but no forced change — or user not found (404 body also has error:true)
          this.setState({ firstLoginMode: false });
        }
      })
      .catch(() => {
        // Network failure — fall back to normal login
        this.setState({ firstLoginMode: false });
      });
  }

  // Form submit handler - fires on the Submit button AND on Enter in any field
  // (browser implicit submission). Routes to whichever flow is on screen and
  // re-checks validation because implicit submission bypasses the button's
  // disabled state when it happens from a field.
  handleSubmit = event => {
    event.preventDefault();
    if (this.state.firstLoginMode) {
      if (this.validateFirstLoginForm()) this.attemptFirstLogin();
    } else if (this.validateForm()) {
      this.attemptLogin();
    }
  }

  attemptLogin = () => {
    this.props.dispatch(loginUser({ username: this.state.username, password: this.state.password }));
  }

  attemptFirstLogin = () => {
    this.setState({ firstLoginError: null });
    fetch('/api/account/first-login-password', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        username: this.state.username,
        newPassword: this.state.newPassword,
        confirmNewPassword: this.state.confirmNewPassword
      })
    })
      .then(r => r.json().then(data => ({ data, ok: r.ok })))
      .then(({ data, ok }) => {
        if (!ok) {
          this.setState({ firstLoginError: data.message || 'An error occurred.' });
          return;
        }
        // Server returned a full auth response — dispatch into Redux the same way
        // that loginUser does after a successful normal login.
        this.props.dispatch(setUser(
          data.user.username,
          data.userId,
          data.userType,
          data.user.locale,
          data.viewPermissions,
          data.docTypePermissions,
          data.localisation,
          false // requirePasswordChange cleared
        ));
        this.props.dispatch(receiveLogin(data));
      })
      .catch(() => {
        this.setState({ firstLoginError: 'Please try again.' });
      });
  }


  render() {

    const { parsed } = this.state
    const { isAuthenticated, errorMessage } = this.props.authReducer
    let alert = {}

    if (errorMessage)
        alert = <Alert color="danger">Login Error: {errorMessage}</Alert>
    else
        alert = <div />


    if (isAuthenticated) {
      // In setup mode, only configuration and license are enabled.
      // Redirect to config page so admin can complete Sage X3 setup.
      const vp = this.props.userReducer?.viewpermissions || {};
      const enabledPages = Object.keys(vp).filter(k => vp[k]?.enabled);
      const isSetupMode = enabledPages.length > 0 &&
        enabledPages.every(k => k === 'configuration' || k === 'license');

      if (isSetupMode) {
        return <Redirect to='/site/config' />
      }
      return <Redirect to='/site/dashboard' />
    }

    return (
        <div className="App">
          <Header visible={!parsed.X3} />
          <content>
          <h3>
              Login
          </h3>
          <br />
          <div className="row justify-content-center s-login-page">
              <div className="col-10 col-sm-7 col-md-5 col-lg-4 s-login-card">
              <Form className="form" onSubmit={this.handleSubmit}>
                <Col>
                  <FormGroup
                   style={{
                    display: 'flex',
                    justifyContent: 'center',
                    flexDirection: 'column',
                  }}
                  >
                    <Label><h6>Username</h6></Label>
                    <Input
                      name="username"
                      id="username"
                      onBlur={this.handleUsernameBlur}
                      className="login-form-control"
                    />
                  </FormGroup>
                </Col>

                {this.state.firstLoginMode ? (
                  // First-login flow: user was imported and must set their own password
                  <>
                    <Col><br />
                      <Alert color="info">
                        Welcome! Your account has been created by an administrator.
                        Please set a password to continue — it must be at least 12 characters.
                      </Alert>
                    </Col>
                    <Col>
                      <FormGroup style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                        <Label><h6>New Password</h6></Label>
                        <Input
                          type="password"
                          name="newPassword"
                          id="newPassword"
                          onChange={this.handleChange}
                          className="login-form-control"
                        />
                      </FormGroup>
                    </Col>
                    <Col><br />
                      <FormGroup style={{ display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                        <Label><h6>Confirm New Password</h6></Label>
                        <Input
                          type="password"
                          name="confirmNewPassword"
                          id="confirmNewPassword"
                          onChange={this.handleChange}
                          className="login-form-control"
                        />
                      </FormGroup><br />
                    </Col>
                    {this.state.firstLoginError && (
                      <Alert color="danger">{this.state.firstLoginError}</Alert>
                    )}
                    <Button
                      type="submit"
                      color="primary"
                      className="btn btn-primary"
                      disabled={!this.validateFirstLoginForm()}
                    >
                      Set Password &amp; Log In
                    </Button>
                  </>
                ) : (
                  // Normal login flow
                  <>
                    <Col><br />
                      <FormGroup
                        style={{
                        display: 'flex',
                        justifyContent: 'center',
                        flexDirection: 'column',
                        }}>
                        <Label for="examplePassword"><h6>Password</h6></Label>
                        <Input
                          type="password"
                          name="password"
                          id="password"
                          onChange={this.handleChange}
                          className="login-form-control"
                        />
                      </FormGroup><br />
                    </Col>
                    {alert}
                    <Button type="submit" color="primary" className="btn btn-primary" disabled={!this.validateForm()}>Submit</Button>
                  </>
                )}
              </Form>
            </div>
          </div>
        <br/>
      </content>
    </div>
    );
  }
}
export default connect(state => state)(Login);
